import React from 'react';

const PassageTextFeedback = ({
    correctAnswer,
    selectedAnswer,
    passage,
}) => {


    let userFeedback = !!passage && passage.map((phrase, i) => {
        return <span key={i}> 
                    <span dangerouslySetInnerHTML={{__html:phrase}}/>
                    {!!selectedAnswer && !!selectedAnswer[i] &&
                          <span className={`filled ${selectedAnswer[i] === correctAnswer[i] ? 'text-success': 'text-danger'}`} >{selectedAnswer[i]}</span>
                    } 
                   </span>
    })

    return (
        <p className="converse-pasage no-mouse-events text-2x addBorder">
                {userFeedback}                                   
            </p>
    )
}


export default PassageTextFeedback;